import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from '../../../constant';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const EstimationDetails = () => {
  const tableHeaders = [
    "#",
    "Product",
    "Variant",
    "Quantity",
    "Gross/Net",
    "Remarks",
    "Action"
  ];

  const [estimationData, setEstimationData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    estimation_id: localStorage.getItem("estimation_id") || "",
    product_id: "",
    variant_id: "",
    qty: "",
    gross_weight: "",
    net_weight: "",
    remarks: "",
  });
const navigate = useNavigate();
const [agencyData, setAgencyData] = useState([]);
const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const username = localStorage.getItem("username");
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
const [filteredVariants, setFilteredVariants] = useState([]); // 👈 new state
  const [storedEstimationInfo, setStoredEstimationInfo] = useState({
    estimation_id: "",
    estimation_number: "",
    estimation_date: "",
    created_by: "",
    status: ""
  });
const [quotationData, setQuotationData] = useState([]);
const [filteredQuotationData, setFilteredQuotationData] = useState([]);
const [showQuotationModal, setShowQuotationModal] = useState(false);
const [pageLoading, setPageLoading] = useState(false);
 const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
const handleViewQuotation = async () => {
  setPageLoading(true);
  const estimation_id = localStorage.getItem("estimation_id");

  try {
    const res = await axios.get(`${var_api}sa_veemart_quotation/get`);
    const data = Array.isArray(res.data) ? res.data : res.data.data || [];

    const filtered = data.filter(
      (q) => Number(q.estimation_id) === Number(estimation_id)
    );
    setFilteredQuotationData(filtered);
    setShowQuotationModal(true);
  } catch {
    toast.error("Failed to load quotation data");
  } finally {
    setPageLoading(false);
  }
};
 const fetchAgencyData = async () => {
  try {
    const res = await axios.get(`${var_api}ci_veemart_supplier_master/get`);
    const agencies = Array.isArray(res.data) ? res.data : res.data.data || [];
    setAgencyData(agencies);
  } catch (err) {
    console.error("Failed to fetch suppliers:", err);
    toast.error("Failed to fetch supplier data");
  }
};
  useEffect(() => {
    loadInitialData();
fetchAgencyData();
    // Load Estimation Info from localStorage
    const savedEstimation = {
      
      estimation_id: localStorage.getItem("estimation_id") || "",
      estimation_number: localStorage.getItem("estimation_number") || "",
      estimation_date: localStorage.getItem("estimation_date") || "",
      created_by: localStorage.getItem("created_by") || userName,
      status: localStorage.getItem("status") || "0"
    };

    setStoredEstimationInfo(savedEstimation);
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchEstimationData();
      await fetchProductData();
      await fetchVariantData();
    } catch (err) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchEstimationData = async () => {
     const estimation_id=localStorage.getItem("estimation_id");

    try {
      // const res = await axios.get(`${var_api}sa_veemart_estimation_detail/get`);
            const res = await axios.get(`${var_api}sa_veemart_estimation_detail/estimation/${estimation_id}`);

      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setEstimationData(data);
    } catch (err) {
      console.error("Fetch Estimation Error:", err);
      toast.error("Failed to fetch estimation details");
    }
  };

  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setProductData(data);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setVariantData(data);
    } catch {
      toast.error("Failed to fetch variants");
    }
  };
// Filter variants when product changes
useEffect(() => {
  if (formData.product_id) {
    const filtered = variantData.filter(v => v.product_id === Number(formData.product_id));
    setFilteredVariants(filtered);
  } else {
    setFilteredVariants([]); // reset if no product chosen
  }
}, [formData.product_id, variantData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      estimation_id: localStorage.getItem("estimation_id") || "",
      product_id: "",
      variant_id: "",
      qty: "",
      gross_weight: "",
      net_weight: "",
      remarks: "",
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = async () => {
  if (!deleteId) return;

  try {
    setLoading(true);
    const res = await axios.delete(`${var_api}sa_veemart_estimation_detail/delete/${deleteId}`);
    toast.success(res?.data?.message || "Record deleted successfully!");
    fetchEstimationData();
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to delete record");
  } finally {
    setLoading(false);
    setShowDeleteModal(false);
    setDeleteId(null);
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.product_id) newErrors.product_id = "Product is required";
    if (!formData.variant_id) newErrors.variant_id = "Variant is required";
if (!formData.qty) newErrors.qty = "Quantity is required";
  else if (Number(formData.qty) <= 0) newErrors.qty = "Quantity must be greater than 0";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_estimation_detail/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}sa_veemart_estimation_detail/post`, formData);
      }
      toast.success(res?.data?.message || "Record saved successfully!");
      setShowModal(false);
      fetchEstimationData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save record");
    } finally {
      setLoading(false);
    }
  };

 const getStatusBadge = (status) => {
    switch (Number(status)) {
      case 0:
        return <span className="badge bg-secondary">Draft</span>;
      case 1:
        return <span className="badge bg-info">Quoted</span>;
      case 2:
        return <span className="badge bg-success">Converted</span>;
      default:
        return <span className="badge bg-light text-dark">Unknown</span>;
    }
  };

const handleDownloadPDF = () => {
  if (estimationData.length === 0) {
    toast.warning("No estimation data to download");
    return;
  }

  // ✅ Get supplier name
  const supplierName =
    filteredQuotationData.length > 0
      ? getSupplierName(filteredQuotationData[0].supplier_id)
      : "N/A";

  const { estimation_number, estimation_date } = storedEstimationInfo;

  const doc = new jsPDF();

  // ===== Header Section =====
  doc.setFontSize(16);
  doc.text("VEEMART ESTIMATION", 14, 15);

  doc.setFontSize(12);
  doc.text(`From: Veemart`, 14, 25);
  doc.text(`To: ${supplierName}`, 14, 32); // ✅ supplier name visible

  doc.text(`Estimation No: ${estimation_number || "-"}`, 14, 42);
  doc.text(
    `Estimation Date: ${
      estimation_date
        ? new Date(estimation_date).toLocaleDateString("en-GB")
        : "-"
    }`,
    14,
    49
  );

  // Line separator
  doc.line(14, 53, 195, 53);

  // ===== Table Section =====
  const tableColumn = [
    "S.No",
    "Product",
    "Variant",
    "Qty",
    "Gross Weight",
    "Net Weight",
  ];
  const tableRows = estimationData.map((item, index) => {
    const productName =
      productData.find((p) => p.id === item.product_id)?.product_name || "-";
    const variantName =
      variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";
    return [
      index + 1,
      productName,
      variantName,
      item.qty,
      item.gross_weight || "-",
      item.net_weight || "-",
    ];
  });

  autoTable(doc, {
    startY: 60,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    headStyles: { fillColor: [22, 160, 133] },
    styles: { fontSize: 10 },
  });

  // ===== Footer Section =====
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(10);
  doc.text("Generated by Veemart System", 14, finalY);
  doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, finalY + 6);

  // Save the file
  doc.save(`Estimation_${estimation_number || "details"}.pdf`);
};


const handleDownloadExcel = () => {
  if (estimationData.length === 0) {
    toast.warning("No estimation data to export");
    return;
  }

  const { estimation_number, estimation_date } = storedEstimationInfo;

  // Create Excel rows
  const rows = estimationData.map((item) => {
    const productName =
      productData.find((p) => p.id === item.product_id)?.product_name || "-";
    const variantName =
      variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";

    return {
      "Estimation Number": estimation_number || "-",
      "Estimation Date": estimation_date
        ? new Date(estimation_date).toLocaleDateString("en-GB")
        : "-",
      Product: productName,
      Variant: variantName,
      Quantity: item.qty,
      "Gross/Net": `${item.gross_weight || "-"} / ${item.net_weight || "-"}`,
    };
  });

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Estimation Details");

  // Convert to Excel file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  // Save file
  saveAs(blob, `Estimation_${estimation_number || "details"}.xlsx`);
};




const getSupplierName = (id) => {
  const supplier = agencyData.find((a) => a.id === id);
  return supplier ? supplier.supplier_name : "-";
};

 const filteredData = estimationData.filter((item) => {
  const productName =
    productData.find((p) => p.id === item.product_id)?.product_name?.toLowerCase() || "";
  const variantName =
    variantData.find((v) => v.id === item.variant_id)?.variant_name?.toLowerCase() || "";
  const qty = String(item.qty || "").toLowerCase();
  const gross = String(item.gross_weight || "").toLowerCase();
  const net = String(item.net_weight || "").toLowerCase();
  const remarks = String(item.remarks || "").toLowerCase();

  const query = searchQuery.toLowerCase();

  return (
    productName.includes(query) ||
    variantName.includes(query) ||
    qty.includes(query) ||
    gross.includes(query) ||
    net.includes(query) ||
    remarks.includes(query)
  );
});

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {/* Estimation Summary */}
  <Card className="p-3 mb-3 shadow-sm">
 <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
  <h5 className="mb-0">Estimation Details</h5>
  <div className="d-flex gap-2">
    <Button
      variant="info"
      size="sm"
      onClick={handleViewQuotation}
      title="View Quotation"
    >
      <i className="fas fa-eye me-2"></i> View Quotation
    </Button>

    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => navigate("/estimation")}
    >
      <i className="fas fa-arrow-left me-2"></i> Back to Estimation
    </Button>
  </div>
</div>


  <Row className="align-items-center g-3 flex-wrap">
    <Col xs="auto">
      <h6>
        <strong>Estimation No:</strong>{" "}
        <span style={{ color: "green" }}>{storedEstimationInfo.estimation_number || "N/A"}</span>
      </h6>
    </Col>
    <Col xs="auto">
      <h6>
        <strong>Date:</strong>{" "}
        <span style={{ color: "green" }}>
          {storedEstimationInfo.estimation_date
            ? new Date(storedEstimationInfo.estimation_date).toLocaleDateString("en-GB")
            : "-"}
        </span>
      </h6>
    </Col>
  <Col xs="auto">
  <h6>
    <strong>Created By:</strong>{" "}
    <span style={{ color: "green" }}>{userName || "N/A"}</span>
  </h6>
</Col>

    <Col xs="auto">
      <h6>
        <strong>Status:</strong> {getStatusBadge(storedEstimationInfo.status)}
      </h6>
    </Col>
  </Row>
</Card>



          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
               <Button
  variant="success"
  size="sm"
  onClick={handleDownloadPDF}
  title="Download Estimation PDF"
>
  <i className="fas fa-file-pdf me-2"></i>Download PDF
</Button>

<Button
  variant="danger"
  size="sm"
  onClick={handleDownloadExcel}
  title="Download Estimation Excel"
>
  <i className="fas fa-file-excel me-2"></i> Export Excel
</Button>


                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                  <Button variant="secondary" onClick={handleAddClick}>
                                  Add
                                </Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>{tableHeaders.map((h, i) => <th key={i}>{h}</th>)}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => {
                        const productName = productData.find(p => p.id === item.product_id)?.product_name || "-";
                        const variantName = variantData.find(v => v.id === item.variant_id)?.variant_name || "-";
                        return (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                            <td>{productName}</td>
                            <td>{variantName}</td>
                            <td>{item.qty}</td>
                            <td>{item.gross_weight}/{item.net_weight}</td>
                            <td>{item.remarks}</td>
                            <td className="text-center">
                             <button
                                className="btn shadow btn-xs sharp"
                                style={{ backgroundColor: "#007bff", color: "white" }}
                                onClick={() => handleEditClick(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                          <button
  className="btn shadow btn-xs sharp"
  style={{ backgroundColor: "#f40c17ff", color: "white" }}
  onClick={() => {
    setDeleteId(item.id);
    setShowDeleteModal(true);
  }}
  title="Delete"
>
  <i className="fas fa-trash"></i>
</button>

                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
<Modal
  show={showQuotationModal}
  onHide={() => setShowQuotationModal(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton className="d-flex justify-content-between align-items-center">
    <Modal.Title className="mb-0">Quotation Details</Modal.Title>
    <Button
      variant="outline-success"
      size="sm"
      onClick={() => navigate("/quotation-details")}
      title="Quotation Details"
      className="d-flex align-items-center"
    >
      <i className="fas fa-external-link-alt me-2"></i>
      View Details
    </Button>
  </Modal.Header>

  <Modal.Body>
    {pageLoading ? (
      <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status"></div>
        <div>Loading Quotation Data...</div>
      </div>
    ) : filteredQuotationData.length === 0 ? (
      <div className="text-center text-muted my-3">
        No quotation found for this estimation.
      </div>
    ) : (
      <div className="table-responsive">
        <table className="table table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Quotation No</th>
              <th>Supplier</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredQuotationData.map((q, idx) => (
              <tr key={q.id}>
                <td>{idx + 1}</td>
                <td>{q.quotation_number}</td>
                <td>{getSupplierName(q.supplier_id)}</td>
                <td>
                  {q.quotation_date
                    ? new Date(q.quotation_date).toLocaleDateString("en-GB")
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={() => setShowQuotationModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Estimation Detail" : "Add Estimation Detail"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
             <Col md={6}>
         <Form.Group className="mb-3">
           <Form.Label>
             Product <span className="text-danger">*</span>
           </Form.Label>
           <Select
             name="product_id"
             value={
               productData
                 .filter((p) => p.id === Number(formData.product_id))
                 .map((p) => ({ value: p.id, label: p.product_name }))[0] || null
             }
             onChange={(selectedOption) => {
               setFormData((prev) => ({
                 ...prev,
                 product_id: selectedOption ? selectedOption.value : "",
                 variant_id: "", // reset variant when product changes
               }));
             }}
             options={productData.map((p) => ({
               value: p.id,
               label: p.product_name,
             }))}
             placeholder="Select Product"
             isClearable
           />
           {errors.product_id && (
             <div className="text-danger small">{errors.product_id}</div>
           )}
         </Form.Group>
       </Col>
       
       <Col md={6}>
         <Form.Group className="mb-3">
           <Form.Label>
             Variant <span className="text-danger">*</span>
           </Form.Label>
           <Select
             name="variant_id"
             value={
               filteredVariants
                 .filter((v) => v.id === Number(formData.variant_id))
                 .map((v) => ({ value: v.id, label: v.variant_name }))[0] || null
             }
             onChange={(selectedOption) => {
               setFormData((prev) => ({
                 ...prev,
                 variant_id: selectedOption ? selectedOption.value : "",
               }));
             }}
             options={filteredVariants.map((v) => ({
               value: v.id,
               label: v.variant_name,
             }))}
             placeholder={
               formData.product_id ? "Select Variant" : "Select Product First"
             }
             isClearable
             isDisabled={!formData.product_id}
           />
           {errors.variant_id && (
             <div className="text-danger small">{errors.variant_id}</div>
           )}
         </Form.Group>
       </Col>

<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>
      Quantity <span className="text-danger">*</span>
    </Form.Label>
    <Form.Control
      type="number"            // ✅ numeric input
      min="1"                  // ✅ minimum value = 1
      name="qty"
      value={formData.qty}
      onChange={(e) => {
        const value = e.target.value;
        setFormData((prev) => ({ ...prev, qty: value }));
        setErrors((prev) => ({ ...prev, qty: "" })); // ✅ clear qty error
      }}
      placeholder="Enter quantity"
    />
    {errors.qty && <div className="text-danger small">{errors.qty}</div>}
  </Form.Group>
</Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gross Weight</Form.Label>
                    <Form.Control name="gross_weight" value={formData.gross_weight} onChange={handleInputChange} placeholder="Enter gross weight" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Net Weight</Form.Label>
                    <Form.Control name="net_weight" value={formData.net_weight} onChange={handleInputChange} placeholder="Enter net weight" />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control name="remarks" value={formData.remarks} onChange={handleInputChange} placeholder="Enter remarks" />
                  </Form.Group>
                </Col>
              </Row>

               <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                          id: null,
    estimation_id: localStorage.getItem("estimation_id") || "",
    product_id: "",
    variant_id: "",
    qty: "",
    gross_weight: "",
    net_weight: "",
    remarks: "",
                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Deletion</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p>Are you sure you want to delete this record? This action cannot be undone.</p>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="danger" onClick={() => setShowDeleteModal(false)}>
      Cancel
    </Button>
    <Button variant="warning" onClick={handleDeleteClick} disabled={loading}>
      {loading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
          Deleting...
        </>
      ) : (
        "Delete"
      )}
    </Button>
  </Modal.Footer>
</Modal>

      </Card>
      <ToastContainer />
    </>
  );
};

export default EstimationDetails;
